// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg width=%2714%27 height=%272%27 viewBox=%270 0 14 2%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M0 0h14v2H0z%27 fill=%27%23FFF%27 fill-rule=%27evenodd%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueListingDetails_title__GnJkT {
  font-size: 36px;
  margin: 0 0 48px;
  text-align: center;
  color: #4a4a4f;
  text-align: left;
}
@media (max-width: 767px) {
  .VenueListingDetails_title__GnJkT {
    font-size: 24px;
    margin: 0 0 16px;
  }
}

.VenueListingDetails_titleHospitality__kxGKd {
  text-align: center;
  font-size: 40px;
}
@media (max-width: 767px) {
  .VenueListingDetails_titleHospitality__kxGKd {
    font-size: 28px;
  }
}

.VenueListingDetails_subTitle__EKbuI {
  color: #4a4a4f;
  font-size: 28px;
}
@media (max-width: 767px) {
  .VenueListingDetails_subTitle__EKbuI {
    font-size: 20px;
  }
}

.VenueListingDetails_rehearsalCheck__SVT3T {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.VenueListingDetails_rehearsalCheck__SVT3T input {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}
.VenueListingDetails_rehearsalCheck__SVT3T input[type=checkbox] {
  accent-color: #064749;
}
.VenueListingDetails_rehearsalCheck__SVT3T label {
  padding: 0;
}

.VenueListingDetails_listingDetailsWrapper__\\+yX5W p,
.VenueListingDetails_listingDetailsWrapper__\\+yX5W label,
.VenueListingDetails_listingDetailsWrapper__\\+yX5W li,
.VenueListingDetails_listingDetailsWrapper__\\+yX5W h6 {
  color: #4a4a4f;
  word-break: break-word;
}

.VenueListingDetails_timeInputs__QVwZ\\+ {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}
.VenueListingDetails_timeInputs__QVwZ\\+ select {
  color: gray;
  font-size: 16px;
}
.VenueListingDetails_timeInputs__QVwZ\\+ > div {
  width: calc(50% - 12px);
}
.VenueListingDetails_timeInputs__QVwZ\\+ svg {
  vertical-align: middle;
  fill: #484848;
  height: 24px;
  width: 24px;
}

.VenueListingDetails_boldText__Z7T6W {
  font-weight: 700;
  text-transform: capitalize;
  color: #4a4a4f;
}

.VenueListingDetails_orderText__z2oQd {
  font-weight: 600;
  text-transform: capitalize;
  color: #4a4a4f;
}

.VenueListingDetails_summaryContent__jrDL- {
  margin: 16px 0px 24px;
  border-radius: 2px;
  background-color: rgba(221, 221, 221, 0.4705882353);
  padding: 12px;
}
@media (max-width: 767px) {
  .VenueListingDetails_summaryContent__jrDL- {
    padding: 8px;
    margin: 12px 12px 16px;
  }
}
.VenueListingDetails_summaryContent__jrDL- h6 {
  border-bottom: 1px solid gray;
  margin-bottom: 12px;
  margin-right: 0 !important;
}
.VenueListingDetails_summaryContent__jrDL- table {
  width: 100%;
  border-collapse: collapse;
}
.VenueListingDetails_summaryContent__jrDL- table tr th {
  text-align: left;
  color: #4a4a4f;
  line-height: 24px;
}
.VenueListingDetails_summaryContent__jrDL- table tr th:nth-child(2) {
  text-align: center;
}
.VenueListingDetails_summaryContent__jrDL- table tr th:last-child {
  text-align: right;
}
.VenueListingDetails_summaryContent__jrDL- table tr td {
  font-size: 15px;
  line-height: 26px;
}
@media (max-width: 767px) {
  .VenueListingDetails_summaryContent__jrDL- table tr td {
    font-size: 14px;
    line-height: 20px;
  }
}
.VenueListingDetails_summaryContent__jrDL- table tr td:nth-child(2) {
  text-align: center;
}
.VenueListingDetails_summaryContent__jrDL- table tr td:last-child {
  text-align: right;
}

.VenueListingDetails_reasonLabel__bd\\+mL {
  font-size: 18px;
  font-weight: 700;
}

.VenueListingDetails_rightTexts__D9djh {
  display: flex;
  align-items: center;
}
.VenueListingDetails_rightTexts__D9djh .VenueListingDetails_priceCount__YLEci {
  font-size: 14px;
}
@media (max-width: 767px) {
  .VenueListingDetails_rightTexts__D9djh .VenueListingDetails_priceCount__YLEci {
    font-size: 14px;
  }
}

.VenueListingDetails_selectMenu__tV7nF {
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.5px;
  border-top: 1px solid rgba(128, 128, 128, 0.159);
}
.VenueListingDetails_selectMenu__tV7nF:nth-child(1) {
  border-top: none;
}
.VenueListingDetails_selectMenu__tV7nF img {
  height: 40px;
  width: 40px;
  border-radius: 100px;
  object-fit: cover;
  margin: 4px 0;
}
.VenueListingDetails_selectMenu__tV7nF .VenueListingDetails_genreText__GUk2N {
  font-size: 12px;
  margin-top: 6px;
}

.VenueListingDetails_multiSelectBox__xnwrZ {
  position: relative;
  z-index: 11;
}
.VenueListingDetails_multiSelectBox__xnwrZ > div {
  border-radius: 6px;
  /* border: 1px solid var(--Web-H-3, #538ABE); */
  color: var(--Black-Shade-Text_Black, #272727);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-color: #b9b9b9;
  padding: 1px 8px;
  /* &:not(:last-child) {
    min-height: 61px;
    @media (max-width: 767px) {
      min-height: 36px;
    }
  } */
}
.VenueListingDetails_multiSelectBox__xnwrZ > div > div {
  /* padding: 5px 8px; */
}
.VenueListingDetails_multiSelectBox__xnwrZ > div input {
  height: auto;
  color: var(--Black-Shade-Text_Black, #272727);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.VenueListingDetails_multiSelectBox__xnwrZ > div input:focus {
  box-shadow: none;
}

.css-1jqq78o-placeholder {
  color: var(--Black-Shade-Text_Black, #272727) !important;
}
.css-1jqq78o-placeholder::placeholder {
  color: var(--Black-Shade-Text_Black, #272727) !important;
}

.css-t3ipsp-control {
  min-height: 48px !important;
}
@media (max-width: 767px) {
  .css-t3ipsp-control {
    min-height: 36px !important;
  }
}

.css-13cymwt-control {
  min-height: 48px !important;
  border: 1px solid #d8dce6 !important;
}
@media (max-width: 767px) {
  .css-13cymwt-control {
    min-height: 36px !important;
  }
}

.css-1nmdiq5-menu {
  position: relative !important;
  z-index: 12 !important;
}

.VenueListingDetails_contentWrapper__fXbQP {
  display: flex;
  gap: 30px;
  margin: 48px 0;
  min-height: 300px;
}
@media (max-width: 1023px) {
  .VenueListingDetails_contentWrapper__fXbQP {
    flex-direction: column;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc {
  width: calc(100% - 548px);
}
@media (max-width: 1023px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc {
    width: 100%;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc .VenueListingDetails_venueTitle__ei9Jy {
  font-size: 40px;
  color: #4a4a4f;
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc .VenueListingDetails_venueTitle__ei9Jy {
    font-size: 28px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc .VenueListingDetails_venueName__ADWeB {
  color: #4a4a4f;
  font-size: 24px;
  margin: 16px 0 36px;
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc .VenueListingDetails_venueName__ADWeB {
    font-size: 18px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc .VenueListingDetails_addressText__kUdZj {
  margin-bottom: 12px;
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc h1 {
    font-size: 24px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc h2 {
  margin: 48px 0 24px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc h3 {
  margin: 24px 0 16px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc ul {
  list-style: unset;
  margin-left: 20px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_leftContents__Ab-Kc ul li {
  margin-bottom: 6px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv {
  width: 500px;
  margin-left: 48px;
  background: rgb(242, 242, 240);
  padding: 48px 36px;
  border-radius: 16px;
  height: -moz-fit-content;
  height: fit-content;
  /* Add an underline for '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
}
@media (max-width: 1300px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv {
    width: 460px;
  }
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv {
    padding: 12px 6px;
    background: none;
    width: 100%;
    margin-left: 0;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_chooseListing__b-clC {
  margin: 0 0 36px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_bookButton__klwCn {
  background-color: #064749;
  color: #fff;
  border-radius: 100px;
  margin-top: 36px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_calendlyButton__JhO5P {
  background-color: #064749;
  color: #fff;
  border-radius: 100px;
  margin-top: 16px;
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_calendlyButton__JhO5P {
    margin-top: 12px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_calendlyButton__JhO5P a {
  text-decoration: none;
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv h6 {
  font-size: 18px;
  margin-right: 16px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContents__LCkRF {
  margin: 0 0 36px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_priceContent__TjQv6 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_priceContent__TjQv6 .VenueListingDetails_priceText__3ecO\\+ {
  text-align: right;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_priceContent__TjQv6 .VenueListingDetails_vatText__LQ\\+zP {
  font-size: 12px;
  white-space: pre;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta .VenueListingDetails_countNumber__xXLAd {
  border: 1px solid rgba(128, 128, 128, 0.74);
  display: inline-block;
  margin-left: 8px;
  border-radius: 4px;
  padding: 1px 0px;
  box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.1);
  white-space: pre;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta .VenueListingDetails_countNumber__xXLAd > span {
  cursor: pointer;
  padding: 0 4px;
  text-align: center;
  font-size: 18px;
  line-height: 22px;
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta .VenueListingDetails_countNumber__xXLAd > span {
    padding: 0 4px;
    font-size: 16px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta .VenueListingDetails_countNumber__xXLAd .VenueListingDetails_countQuantity__167OU {
  padding: 0 8px;
  border-left: 1px solid rgba(128, 128, 128, 0.5098039216);
  border-right: 1px solid rgba(128, 128, 128, 0.5098039216);
  cursor: auto;
  font-size: 16px;
}
@media (max-width: 767px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta .VenueListingDetails_countNumber__xXLAd .VenueListingDetails_countQuantity__167OU {
    font-size: 14px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta input {
  height: 16px;
  width: 16px;
  margin-right: 11px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta input[type=checkbox] {
  accent-color: #064749;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_orderContent__q9Wta label {
  padding: 0;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_registeredText__cTTb2 {
  color: red;
  text-align: center;
  margin: 16px 0;
  font-size: 14px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .VenueListingDetails_calenderText__gjEBn {
  margin-bottom: 8px !important;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateRangePicker {
  display: block;
  margin-bottom: 24px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateRangePicker_picker__directionLeft {
  /* !important is added to top because react-dates uses inline style for height */
  /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */
  box-shadow: var(--boxShadowButton);
  top: 36px !important;
  left: unset !important;
  width: calc(100% - 48px);
  background-color: #064749;
}
@media (min-width: 768px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateRangePicker_picker__directionLeft {
    /* !important is added to top because react-dates uses inline style for height */
    /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */
    top: 48px !important;
    left: 0px !important;
    width: 100%;
    min-height: calc(100vh - 252px);
    min-height: auto;
    border-radius: 0 0 6px 6px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateInput_input {
  font-family: var(--fontFamily);
  font-weight: var(--fontWeightMedium);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.1px;
  display: block;
  width: 100%;
  padding: 6px 12px 4px;
  margin: 0;
  border-radius: 6px;
  border: 1px solid #d8dce6;
  background-color: #fff;
  outline: none;
  transition: all 0.1s ease-in-out;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateInput_input:focus {
  border-radius: 6px 6px 0 0;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  transition: all ease-in-out 100ms;
}
@media (min-width: 768px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateInput_input {
    line-height: 32px;
    padding: 7px 16px;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateRangePickerInput {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border: none;
  background-color: transparent;
  align-items: center;
  gap: 8px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPicker__horizontal {
  margin: 0 auto;
  background-color: #064749;
  box-shadow: none;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPickerNavigation__horizontal {
  position: relative;
  width: 100%;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPickerNavigation_button__horizontal {
  padding: 6px 9px;
  top: 16px;
  position: absolute;
  cursor: pointer;
  display: inline;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPickerNavigation_button__horizontal:first-of-type {
  left: 24px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPickerNavigation_button__horizontal:last-of-type {
  right: 24px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPickerNavigation_button {
  color: #fff;
  border: 0;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarMonth, .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarMonthGrid {
  background-color: transparent;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateInput {
  display: block;
  width: 100%;
  background: transparent;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPicker_weekHeader {
  color: #fff;
  top: 57px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPicker_weekHeader_li {
  font-weight: var(--fontWeightRegular);
  color: #fff;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPicker_weekHeader_ul_1 {
  margin: 10px 0 0 !important;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DayPicker__withBorder {
  border-radius: 0;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarMonth_caption {
  font-weight: var(--fontWeightRegular);
  font-size: 21px;
  line-height: 24px;
  color: #fff;
  margin: 1px 0 14px;
}
@media (min-width: 768px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarMonth_caption {
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 0;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__default {
  background-color: #064749;
  border: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay {
  font-weight: var(--fontWeightMedium);
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
  color: #fff;
  border: 0;
  margin-top: 0;
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay {
    font-weight: var(--fontWeightMedium);
    margin-top: 0;
    margin-bottom: 0;
  }
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__today .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center 34px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__hovered_span, .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__selected_span {
  background-image: transparent;
  background-color: #000;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__hovered_span .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: var(--DateRangeInput_hoveredOverlayColor);
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__selected_span .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: green;
  transition: all 0.2s ease-out;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__selected_start {
  background-color: #000;
  background-image: none;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__selected_start .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: green;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__after-hovered_start {
  background-color: transparent;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__after-hovered_start .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: var(--DateRangeInput_hoveredOverlayColor);
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__selected_end {
  background-color: #000;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__selected_end .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: green;
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
  color: #fff;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay:hover .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: var(--DateRangeInput_hoveredOverlayColor);
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_out_of_range, .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_out_of_range:active, .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_out_of_range:hover {
  background-color: transparent;
  color: #000;
  border: 0;
  opacity: 0.8;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_calendar, .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_calendar:active, .VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_calendar:hover {
  background-color: transparent;
  color: #000;
  border: 0;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarDay__blocked_out_of_range
          .CalendarDay__blocked_calendar
          .renderedDay {
  background-color: transparent;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateInput_fang {
  display: none;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .CalendarMonth_caption {
  text-transform: capitalize;
}
.VenueListingDetails_contentWrapper__fXbQP .VenueListingDetails_orderWrapper__NbpDv .DateInput_input__disabled {
  font-style: normal;
}

/* availableAccessories */
.VenueListingDetails_availableAccessories__94\\+V8 {
  margin: 120px 0 0;
}
@media (max-width: 1023px) {
  .VenueListingDetails_availableAccessories__94\\+V8 {
    margin: 60px 0 0;
  }
}
.VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC {
  display: flex;
  gap: 30px;
  justify-content: space-between;
  flex-wrap: wrap;
}
@media (max-width: 1023) {
  .VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC {
    justify-content: center;
  }
}
.VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC .VenueListingDetails_accessoriesColumn__T-jHU {
  max-width: 320px;
  width: 100%;
}
.VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC .VenueListingDetails_accessoriesContent__TF9B- {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC .VenueListingDetails_accessoriesContent__TF9B- svg, .VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC .VenueListingDetails_accessoriesContent__TF9B- img {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.VenueListingDetails_availableAccessories__94\\+V8 .VenueListingDetails_accessoriesContents__UkNcC .VenueListingDetails_accessoriesContent__TF9B- h6 {
  font-size: 18px;
  font-weight: 500;
}

/* hospitalityWrapper */
.VenueListingDetails_hospitalityWrapper__hZpYW {
  margin: 120px 0 0;
}
@media (max-width: 1023px) {
  .VenueListingDetails_hospitalityWrapper__hZpYW {
    margin: 60px 0 0;
  }
}
.VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityColumns__bY2ZI {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}
@media (max-width: 767px) {
  .VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityColumns__bY2ZI {
    flex-direction: column;
  }
}
.VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityColumns__bY2ZI > div {
  max-width: 320px;
  width: 100%;
}
.VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityContents__BE6gq {
  margin-top: 36px;
}
.VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityContents__BE6gq .VenueListingDetails_hospitalityContent__5WFm8 {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityContents__BE6gq .VenueListingDetails_hospitalityContent__5WFm8 .VenueListingDetails_textBold__1gnZu {
  font-weight: 700;
}
.VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityContents__BE6gq .VenueListingDetails_hospitalityContent__5WFm8 svg, .VenueListingDetails_hospitalityWrapper__hZpYW .VenueListingDetails_hospitalityContents__BE6gq .VenueListingDetails_hospitalityContent__5WFm8 img {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}

.VenueListingDetails_fileAttachments__0gJB- {
  margin: 120px 0 0;
}
@media (max-width: 1023px) {
  .VenueListingDetails_fileAttachments__0gJB- {
    margin: 60px 0 0;
  }
}
.VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq {
  display: flex;
  gap: 16px;
  flex-direction: column;
}
.VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq .VenueListingDetails_attachmentsContent__xS6Sx {
  display: flex;
}
@media (max-width: 1023px) {
  .VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq .VenueListingDetails_attachmentsContent__xS6Sx {
    flex-direction: column;
  }
}
.VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq .VenueListingDetails_attachmentsContent__xS6Sx .VenueListingDetails_attachmentsText__EYkET {
  margin-bottom: 16px;
  font-size: 20px;
  margin-right: 12px;
  font-weight: 700;
}
@media (max-width: 1023px) {
  .VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq .VenueListingDetails_attachmentsContent__xS6Sx .VenueListingDetails_attachmentsText__EYkET {
    margin-bottom: 8px;
    font-size: 18px;
  }
}
.VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq .VenueListingDetails_attachmentsContent__xS6Sx .VenueListingDetails_linkText__\\+hM2o {
  color: #4646f3;
  font-size: 20px;
  word-break: break-all;
  font-weight: 600;
}
@media (max-width: 1023px) {
  .VenueListingDetails_fileAttachments__0gJB- .VenueListingDetails_attachmentsContents__90qsq .VenueListingDetails_attachmentsContent__xS6Sx .VenueListingDetails_linkText__\\+hM2o {
    font-size: 18px;
  }
}

/* locationWrapper */
.VenueListingDetails_locationWrapper__8wkaq {
  margin: 120px 0;
}
@media (max-width: 1023px) {
  .VenueListingDetails_locationWrapper__8wkaq {
    margin: 60px 0;
  }
}
.VenueListingDetails_locationWrapper__8wkaq .VenueListingDetails_mapContents__0Ke4J img, .VenueListingDetails_locationWrapper__8wkaq .VenueListingDetails_mapContents__0Ke4J iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  object-fit: cover;
}
.VenueListingDetails_locationWrapper__8wkaq .VenueListingDetails_mapContents__0Ke4J .VenueListingDetails_mapBox__Bcu6d {
  border: 1px solid grey;
  border-radius: 4px;
  padding: 24px;
  position: relative;
  width: 100%;
  padding-top: 60%;
  overflow: hidden;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.3);
}
@media (max-width: 767px) {
  .VenueListingDetails_locationWrapper__8wkaq .VenueListingDetails_mapContents__0Ke4J .VenueListingDetails_mapBox__Bcu6d {
    padding-top: 120%;
  }
}

.VenueListingDetails_spinner__jep4i {
  width: 35px;
  height: 35px;
  stroke: gray;
  stroke-width: 3px;
}

.VenueListingDetails_blur__AGBd8 {
  color: transparent;
  text-shadow: 0 0 8px #000;
}

.VenueListingDetails_capitalize__XUkvi {
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/VenueListingDetails/VenueListingDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AACF;AAAE;EANF;IAOI,eAAA;IACA,gBAAA;EAGF;AACF;;AADA;EACE,kBAAA;EACA,eAAA;AAIF;AAHE;EAHF;IAII,eAAA;EAMF;AACF;;AAJA;EACE,cAAA;EACA,eAAA;AAOF;AANE;EAHF;IAII,eAAA;EASF;AACF;;AAPA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAUF;AATE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAWJ;AATE;EACE,qBAAA;AAWJ;AARE;EACE,UAAA;AAUJ;;AANE;;;;EAIE,cAAA;EACA,sBAAA;AASJ;;AANA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AASF;AARE;EACE,WAAA;EACA,eAAA;AAUJ;AARE;EACE,uBAAA;AAUJ;AARE;EACE,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAUJ;;AAPA;EACE,gBAAA;EACA,0BAAA;EACA,cAAA;AAUF;;AARA;EACE,gBAAA;EACA,0BAAA;EACA,cAAA;AAWF;;AATA;EACE,qBAAA;EACA,kBAAA;EACA,mDAAA;EACA,aAAA;AAYF;AAXE;EALF;IAMI,YAAA;IACA,sBAAA;EAcF;AACF;AAbE;EACE,6BAAA;EACA,mBAAA;EACA,0BAAA;AAeJ;AAZE;EACE,WAAA;EACA,yBAAA;AAcJ;AATM;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAWR;AAVQ;EACE,kBAAA;AAYV;AAVQ;EACE,iBAAA;AAYV;AATM;EACE,eAAA;EACA,iBAAA;AAWR;AAVQ;EAHF;IAII,eAAA;IACA,iBAAA;EAaR;AACF;AAZQ;EACE,kBAAA;AAcV;AAZQ;EACE,iBAAA;AAcV;;AARA;EACE,eAAA;EACA,gBAAA;AAWF;;AATA;EACE,aAAA;EACA,mBAAA;AAYF;AAXE;EACE,eAAA;AAaJ;AAZI;EAFF;IAGI,eAAA;EAeJ;AACF;;AAZA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,gDAAA;AAeF;AAdE;EACE,gBAAA;AAgBJ;AAdE;EACE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;AAgBJ;AAdE;EACE,eAAA;EACA,eAAA;AAgBJ;;AAbA;EACI,kBAAA;EACF,WAAA;AAgBF;AAfE;EACE,kBAAA;EACA,+CAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA;;;;;KAAA;AAsBJ;AAhBI;EACE,sBAAA;AAkBN;AAhBI;EACE,YAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAkBN;AAjBM;EACE,gBAAA;AAmBR;;AAdA;EACE,wDAAA;AAiBF;AAhBE;EACE,wDAAA;AAkBJ;;AAfA;EACE,2BAAA;AAkBF;AAjBE;EAFF;IAGI,2BAAA;EAoBF;AACF;;AAlBA;EACE,2BAAA;EACA,oCAAA;AAqBF;AApBE;EAHF;IAII,2BAAA;EAuBF;AACF;;AArBA;EACE,6BAAA;EACA,sBAAA;AAwBF;;AArBA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;AAwBF;AAvBE;EALF;IAMI,sBAAA;EA0BF;AACF;AAzBE;EACE,yBAAA;AA2BJ;AA1BI;EAFF;IAGI,WAAA;EA6BJ;AACF;AA5BI;EACE,eAAA;EACA,cAAA;AA8BN;AA7BM;EAHF;IAII,eAAA;EAgCN;AACF;AA3BI;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AA6BN;AA5BM;EAJF;IAKI,eAAA;EA+BN;AACF;AA7BI;EACE,mBAAA;AA+BN;AA5BM;EADF;IAEI,eAAA;EA+BN;AACF;AA7BI;EACE,mBAAA;AA+BN;AA7BI;EACE,mBAAA;AA+BN;AA7BI;EACE,iBAAA;EACA,iBAAA;AA+BN;AA9BM;EACE,kBAAA;AAgCR;AA5BE;EACE,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EAiRA,wCAAA;EAWA,0EAAA;EAuBA,0EAAA;EAeA,0EAAA;EAYA,0EAAA;EAuBA,0EAAA;EASA,0EAAA;AAzUJ;AApCI;EAPF;IAQI,YAAA;EAuCJ;AACF;AAtCI;EAVF;IAWI,iBAAA;IACA,gBAAA;IACA,WAAA;IACA,cAAA;EAyCJ;AACF;AAxCI;EACE,gBAAA;AA0CN;AAxCI;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AA0CN;AAxCI;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AA0CN;AAzCM;EALF;IAMI,gBAAA;EA4CN;AACF;AA3CM;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA6CR;AA1CI;EACE,eAAA;EACA,kBAAA;AA4CN;AA1CI;EACE,gBAAA;AA4CN;AA1CI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA4CN;AA3CM;EACE,iBAAA;AA6CR;AA3CM;EACE,eAAA;EACA,gBAAA;AA6CR;AA1CI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AA4CN;AA3CM;EACE,2CAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;EACA,gBAAA;AA6CR;AA5CQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AA8CV;AA7CU;EANF;IAOI,cAAA;IACA,eAAA;EAgDV;AACF;AA9CQ;EACE,cAAA;EACA,wDAAA;EACA,yDAAA;EACA,YAAA;EACA,eAAA;AAgDV;AA/CU;EANF;IAOI,eAAA;EAkDV;AACF;AA/CM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAiDR;AA/CM;EACE,qBAAA;AAiDR;AA/CM;EACE,UAAA;AAiDR;AA9CI;EACE,UAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAgDN;AA9CI;EACE,6BAAA;AAgDN;AA9CI;EACE,cAAA;EACA,mBAAA;AAgDN;AA7CI;EACE,gFAAA;EACA,kFAAA;EACA,kCAAA;EACA,oBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;AA+CN;AA9CM;EARF;IASI,gFAAA;IACA,kFAAA;IACA,oBAAA;IACA,oBAAA;IACA,WAAA;IACA,+BAAA;IACA,gBAAA;IACA,0BAAA;EAiDN;AACF;AA9CI;EACE,8BAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EAEA,cAAA;EACA,WAAA;EAEA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EAEA,gCAAA;AA6CN;AA3CM;EACE,0BAAA;EACA,qBAAA;EACA,gDAAA;EACA,iCAAA;AA6CR;AA1CM;EA1BF;IA2BI,iBAAA;IACA,iBAAA;EA6CN;AACF;AA1CI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,QAAA;AA4CN;AA1CI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;AA4CN;AAzCI;EACE,kBAAA;EACA,WAAA;AA2CN;AAxCI;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA0CN;AAxCM;EACE,UAAA;AA0CR;AAvCM;EACE,WAAA;AAyCR;AArCI;EACE,WAAA;EACA,SAAA;AAuCN;AApCI;EAEE,6BAAA;AAqCN;AAnCI;EACE,cAAA;EACA,WAAA;EACA,uBAAA;AAqCN;AAnCI;EACE,WAAA;EACA,SAAA;AAqCN;AAlCI;EACE,qCAAA;EACA,WAAA;AAoCN;AAlCI;EACE,2BAAA;AAoCN;AAjCI;EACE,gBAAA;AAmCN;AAhCI;EACE,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAkCN;AAhCM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,gBAAA;EAmCN;AACF;AAhCI;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAkCN;AAhCI;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AAiCN;AA/BM;EAXF;IAYI,oCAAA;IACA,aAAA;IACA,gBAAA;EAkCN;AACF;AA9BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,gCAAA;AAgCN;AA5BI;EAEE,6BAAA;EACA,sBAAA;AA6BN;AA3BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;AA6BN;AA3BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;AA6BN;AA1BI;EACE,sBAAA;EACA,sBAAA;AA4BN;AA1BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;AA4BN;AAzBI;EACE,6BAAA;AA2BN;AAzBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;AA2BN;AAxBI;EACE,sBAAA;AA0BN;AAxBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,WAAA;AA0BN;AAxBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;AA0BN;AAvBI;EAGE,6BAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAuBN;AApBI;EAGE,6BAAA;EACA,WAAA;EACA,SAAA;AAoBN;AAlBI;;;EAME,6BAAA;AAiBN;AAfI;EACE,aAAA;AAiBN;AAfI;EACE,0BAAA;AAiBN;AAdI;EACE,kBAAA;AAgBN;;AAXA,yBAAA;AACA;EACE,iBAAA;AAcF;AAbE;EAFF;IAGI,gBAAA;EAgBF;AACF;AAfE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,eAAA;AAiBJ;AAhBI;EALF;IAMI,uBAAA;EAmBJ;AACF;AAlBI;EACE,gBAAA;EACA,WAAA;AAoBN;AAlBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAoBN;AAnBM;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;AAoBR;AAlBM;EACE,eAAA;EACA,gBAAA;AAoBR;;AAfA,uBAAA;AACA;EACE,iBAAA;AAkBF;AAjBE;EAFF;IAGI,gBAAA;EAoBF;AACF;AAnBE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAqBJ;AApBI;EAJF;IAKI,sBAAA;EAuBJ;AACF;AAtBI;EACE,gBAAA;EACA,WAAA;AAwBN;AArBE;EACE,gBAAA;AAuBJ;AAtBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAwBN;AAvBM;EACE,gBAAA;AAyBR;AAvBM;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;AAwBR;;AAnBA;EACE,iBAAA;AAsBF;AArBE;EAFF;IAGI,gBAAA;EAwBF;AACF;AAvBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AAyBJ;AAxBI;EACE,aAAA;AA0BN;AAzBM;EAFF;IAGI,sBAAA;EA4BN;AACF;AA3BM;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA6BR;AA5BQ;EALF;IAMI,kBAAA;IACA,eAAA;EA+BR;AACF;AA7BM;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AA+BR;AA9BQ;EALF;IAMI,eAAA;EAiCR;AACF;;AA5BA,oBAAA;AACA;EACE,eAAA;AA+BF;AA9BE;EAFF;IAGI,cAAA;EAiCF;AACF;AA/BI;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAgCN;AA9BI;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;AAgCN;AA/BM;EATF;IAUI,iBAAA;EAkCN;AACF;;AA9BA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAiCF;;AA/BA;EACE,kBAAA;EACA,yBAAA;AAkCF;;AAhCA;EACE,0BAAA;AAmCF","sourcesContent":[".title {\n  font-size: 36px;\n  margin: 0 0 48px;\n  text-align: center;\n  color: #4a4a4f;\n  text-align: left;\n  @media (max-width: 767px) {\n    font-size: 24px;\n    margin: 0 0 16px;\n  }\n}\n.titleHospitality {\n  text-align: center;\n  font-size: 40px;\n  @media (max-width: 767px) {\n    font-size: 28px;\n  }\n}\n.subTitle {\n  color: #4a4a4f;\n  font-size: 28px;\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n.rehearsalCheck {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  & input {\n    width: 18px;\n    height: 18px;\n    margin-right: 6px;\n  }\n  & input[type=\"checkbox\"] {\n    accent-color: #064749;\n  }\n\n  & label {\n    padding: 0;\n  }\n}\n.listingDetailsWrapper {\n  p,\n  label,\n  li,\n  h6 {\n    color: #4a4a4f;\n    word-break: break-word;\n  }\n}\n.timeInputs {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  & select {\n    color: gray;\n    font-size: 16px;\n  }\n  & > div {\n    width: calc(50% - 12px);\n  }\n  & svg {\n    vertical-align: middle;\n    fill: #484848;\n    height: 24px;\n    width: 24px;\n  }\n}\n.boldText {\n  font-weight: 700;\n  text-transform: capitalize;\n  color: #4a4a4f;\n}\n.orderText {\n  font-weight: 600;\n  text-transform: capitalize;\n  color: #4a4a4f;\n}\n.summaryContent {\n  margin: 16px 0px 24px;\n  border-radius: 2px;\n  background-color: #dddddd78;\n  padding: 12px;\n  @media (max-width: 767px) {\n    padding: 8px;\n    margin: 12px 12px 16px;\n  }\n  & h6 {\n    border-bottom: 1px solid gray;\n    margin-bottom: 12px;\n    margin-right: 0 !important;\n  }\n\n  & table {\n    width: 100%;\n    border-collapse: collapse;\n    & tr {\n      // &:nth-child(even) {\n      //   background-color: #dddddd78;\n      // }\n      & th {\n        text-align: left;\n        color: #4a4a4f;\n        line-height: 24px;\n        &:nth-child(2) {\n          text-align: center;\n        }\n        &:last-child {\n          text-align: right;\n        }\n      }\n      & td {\n        font-size: 15px;\n        line-height: 26px;\n        @media (max-width: 767px) {\n          font-size: 14px;\n          line-height: 20px;\n        }\n        &:nth-child(2) {\n          text-align: center;\n        }\n        &:last-child {\n          text-align: right;\n        }\n      }\n    }\n  }\n}\n.reasonLabel {\n  font-size: 18px;\n  font-weight: 700;\n}\n.rightTexts {\n  display: flex;\n  align-items: center;\n  & .priceCount {\n    font-size: 14px;\n    @media (max-width: 767px) {\n      font-size: 14px;\n    }\n  }\n}\n.selectMenu{\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  letter-spacing: 0.5px;\n  border-top: 1px solid rgba(128, 128, 128, 0.159);\n  &:nth-child(1){\n    border-top: none;\n  }\n  & img{\n    height: 40px;\n    width: 40px;\n    border-radius: 100px;\n    object-fit: cover;\n    margin: 4px 0;\n  }\n  & .genreText{\n    font-size: 12px;\n    margin-top: 6px;\n  }\n}\n.multiSelectBox {\n    position: relative;\n  z-index: 11;\n  & > div {\n    border-radius: 6px;\n    /* border: 1px solid var(--Web-H-3, #538ABE); */\n    color: var(--Black-Shade-Text_Black, #272727);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    border-color: #b9b9b9;\n    padding: 1px 8px;\n    /* &:not(:last-child) {\n      min-height: 61px;\n      @media (max-width: 767px) {\n        min-height: 36px;\n      }\n    } */\n    & > div {\n      /* padding: 5px 8px; */\n    }\n    & input {\n      height: auto;\n      color: var(--Black-Shade-Text_Black, #272727);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n}\n:global(.css-1jqq78o-placeholder){\n  color: var(--Black-Shade-Text_Black, #272727) !important;\n  &::placeholder{\n    color: var(--Black-Shade-Text_Black, #272727) !important;\n  }\n}\n:global(.css-t3ipsp-control){\n  min-height: 48px !important;\n  @media (max-width: 767px) {\n    min-height: 36px !important;\n  }\n}\n:global(.css-13cymwt-control){\n  min-height: 48px !important;\n  border: 1px solid #d8dce6 !important;\n  @media (max-width: 767px) {\n    min-height: 36px !important;\n  }\n}\n:global(.css-1nmdiq5-menu){\n  position: relative !important;\n  z-index: 12 !important;\n}\n\n.contentWrapper {\n  display: flex;\n  gap: 30px;\n  margin: 48px 0;\n  min-height: 300px;\n  @media (max-width: 1023px) {\n    flex-direction: column;\n  }\n  & .leftContents {\n    width: calc(100% - 548px);\n    @media (max-width: 1023px) {\n      width: 100%;\n    }\n    & .venueTitle {\n      font-size: 40px;\n      color: #4a4a4f;\n      @media (max-width: 767px) {\n        font-size: 28px;\n      }\n    }\n    // & .venueTag {\n\n    // }\n    & .venueName {\n      color: #4a4a4f;\n      font-size: 24px;\n      margin: 16px 0 36px;\n      @media (max-width: 767px) {\n        font-size: 18px;\n      }\n    }\n    & .addressText {\n      margin-bottom: 12px;\n    }\n    & h1 {\n      @media (max-width: 767px) {\n        font-size: 24px;\n      }\n    }\n    & h2 {\n      margin: 48px 0 24px;\n    }\n    & h3 {\n      margin: 24px 0 16px;\n    }\n    & ul {\n      list-style: unset;\n      margin-left: 20px;\n      & li {\n        margin-bottom: 6px;\n      }\n    }\n  }\n  & .orderWrapper {\n    width: 500px;\n    margin-left: 48px;\n    background: rgb(242 242 240);\n    padding: 48px 36px;\n    border-radius: 16px;\n    height: fit-content;\n    @media (max-width: 1300px) {\n      width: 460px;\n    }\n    @media (max-width: 767px) {\n      padding: 12px 6px;\n      background: none;\n      width: 100%;\n      margin-left: 0;\n    }\n    & .chooseListing{\n      margin: 0 0 36px;\n    }\n    & .bookButton {\n      background-color: #064749;\n      color: #fff;\n      border-radius: 100px;\n      margin-top: 36px;\n    }\n    & .calendlyButton {\n      background-color: #064749;\n      color: #fff;\n      border-radius: 100px;\n      margin-top: 16px;\n      @media (max-width: 767px) {\n        margin-top: 12px;\n      }\n      & a {\n        text-decoration: none;\n        color: #fff;\n        width: 100%;\n        height: 100%;\n        display: block;\n      }\n    }\n    & h6 {\n      font-size: 18px;\n      margin-right: 16px;\n    }\n    & .orderContents {\n      margin: 0 0 36px;\n    }\n    & .priceContent {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 20px;\n      & .priceText {\n        text-align: right;\n      }\n      & .vatText {\n        font-size: 12px;\n        white-space: pre;\n      }\n    }\n    & .orderContent {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin: 12px 0;\n      & .countNumber {\n        border: 1px solid rgb(128 128 128 / 74%);\n        display: inline-block;\n        margin-left: 8px;\n        border-radius: 4px;\n        padding: 1px 0px;\n        box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.1);\n        white-space: pre;\n        & > span {\n          cursor: pointer;\n          padding: 0 4px;\n          text-align: center;\n          font-size: 18px;\n          line-height: 22px;\n          @media (max-width: 767px) {\n            padding: 0 4px;\n            font-size: 16px;\n          }\n        }\n        & .countQuantity {\n          padding: 0 8px;\n          border-left: 1px solid #80808082;\n          border-right: 1px solid #80808082;\n          cursor: auto;\n          font-size: 16px;\n          @media (max-width: 767px) {\n            font-size: 14px;\n          }\n        }\n      }\n      & input {\n        height: 16px;\n        width: 16px;\n        margin-right: 11px;\n      }\n      & input[type=\"checkbox\"] {\n        accent-color: #064749;\n      }\n      & label {\n        padding: 0;\n      }\n    }\n    & .registeredText {\n      color: red;\n      text-align: center;\n      margin: 16px 0;\n      font-size: 14px;\n    }\n    & .calenderText {\n      margin-bottom: 8px !important;\n    }\n    & :global(.DateRangePicker) {\n      display: block;\n      margin-bottom: 24px;\n    }\n\n    & :global(.DateRangePicker_picker__directionLeft) {\n      /* !important is added to top because react-dates uses inline style for height */\n      /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */\n      box-shadow: var(--boxShadowButton);\n      top: 36px !important;\n      left: unset !important;\n      width: calc(100% - 48px);\n      background-color: #064749;\n      @media (min-width: 768px) {\n        /* !important is added to top because react-dates uses inline style for height */\n        /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */\n        top: 48px !important;\n        left: 0px !important;\n        width: 100%;\n        min-height: calc(100vh - 252px);\n        min-height: auto;\n        border-radius: 0 0 6px 6px;\n      }\n    }\n\n    & :global(.DateInput_input) {\n      font-family: var(--fontFamily);\n      font-weight: var(--fontWeightMedium);\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: -0.1px;\n\n      display: block;\n      width: 100%;\n\n      padding: 6px 12px 4px;\n      margin: 0;\n      border-radius: 6px;\n      border: 1px solid #d8dce6;\n      background-color: #fff;\n      outline: none;\n\n      transition: all 0.1s ease-in-out;\n\n      &:focus {\n        border-radius: 6px 6px 0 0;\n        border-color: #80bdff;\n        box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);\n        transition: all ease-in-out 100ms;\n      }\n\n      @media (min-width: 768px) {\n        line-height: 32px;\n        padding: 7px 16px;\n      }\n    }\n\n    & :global(.DateRangePickerInput) {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      border: none;\n      background-color: transparent;\n      align-items: center;\n      gap: 8px;\n    }\n    & :global(.DayPicker__horizontal) {\n      margin: 0 auto;\n      background-color: #064749;\n      box-shadow: none;\n    }\n\n    & :global(.DayPickerNavigation__horizontal) {\n      position: relative;\n      width: 100%;\n    }\n\n    & :global(.DayPickerNavigation_button__horizontal) {\n      padding: 6px 9px;\n      top: 16px;\n      position: absolute;\n      cursor: pointer;\n      display: inline;\n\n      &:first-of-type {\n        left: 24px;\n      }\n\n      &:last-of-type {\n        right: 24px;\n      }\n    }\n\n    & :global(.DayPickerNavigation_button) {\n      color: #fff;\n      border: 0;\n    }\n\n    & :global(.CalendarMonth),\n    & :global(.CalendarMonthGrid) {\n      background-color: transparent;\n    }\n    & :global(.DateInput) {\n      display: block;\n      width: 100%;\n      background: transparent;\n    }\n    & :global(.DayPicker_weekHeader) {\n      color: #fff;\n      top: 57px;\n    }\n\n    & :global(.DayPicker_weekHeader_li) {\n      font-weight: var(--fontWeightRegular);\n      color: #fff;\n    }\n    & :global(.DayPicker_weekHeader_ul_1) {\n      margin: 10px 0 0 !important;\n    }\n\n    & :global(.DayPicker__withBorder) {\n      border-radius: 0;\n    }\n\n    & :global(.CalendarMonth_caption) {\n      font-weight: var(--fontWeightRegular);\n      font-size: 21px;\n      line-height: 24px;\n      color: #fff;\n      margin: 1px 0 14px;\n\n      @media (min-width: 768px) {\n        line-height: 32px;\n        margin-top: 0;\n        margin-bottom: 0;\n      }\n    }\n\n    & :global(.CalendarDay__default) {\n      background-color: #064749;\n      border: 0;\n      padding: 0;\n      width: 100%;\n      height: 100%;\n    }\n    & :global(.CalendarDay) {\n      font-weight: var(--fontWeightMedium);\n      font-size: 15px;\n      line-height: 24px;\n      letter-spacing: 0;\n\n      color: #fff;\n      border: 0;\n      margin-top: 0;\n      margin-bottom: 0;\n\n      @media (min-width: 768px) {\n        font-weight: var(--fontWeightMedium);\n        margin-top: 0;\n        margin-bottom: 0;\n      }\n    }\n\n    /* Add an underline for '.renderedDay' */\n    & :global(.CalendarDay__today .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-image: url(\"data:image/svg+xml;utf8,<svg width='14' height='2' viewBox='0 0 14 2' xmlns='http://www.w3.org/2000/svg'><path d='M0 0h14v2H0z' fill='%23FFF' fill-rule='evenodd'/></svg>\");\n      background-position: center 34px;\n    }\n\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__hovered_span),\n    & :global(.CalendarDay__selected_span) {\n      background-image: transparent;\n      background-color: #000;\n    }\n    & :global(.CalendarDay__hovered_span .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: var(--DateRangeInput_hoveredOverlayColor);\n    }\n    & :global(.CalendarDay__selected_span .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: green;\n      transition: all 0.2s ease-out;\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__selected_start) {\n      background-color: #000;\n      background-image: none;\n    }\n    & :global(.CalendarDay__selected_start .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: green;\n      border-top-left-radius: calc(36px / 2);\n      border-bottom-left-radius: calc(36px / 2);\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__after-hovered_start) {\n      background-color: transparent;\n    }\n    & :global(.CalendarDay__after-hovered_start .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: var(--DateRangeInput_hoveredOverlayColor);\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__selected_end) {\n      background-color: #000;\n    }\n    & :global(.CalendarDay__selected_end .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: green;\n      border-top-right-radius: calc(36px / 2);\n      border-bottom-right-radius: calc(36px / 2);\n      color: #fff;\n    }\n    & :global(.CalendarDay:hover .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: var(--DateRangeInput_hoveredOverlayColor);\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__blocked_out_of_range),\n    & :global(.CalendarDay__blocked_out_of_range:active),\n    & :global(.CalendarDay__blocked_out_of_range:hover) {\n      background-color: transparent;\n      color: #000;\n      border: 0;\n      opacity: 0.8;\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__blocked_calendar),\n    & :global(.CalendarDay__blocked_calendar:active),\n    & :global(.CalendarDay__blocked_calendar:hover) {\n      background-color: transparent;\n      color: #000;\n      border: 0;\n    }\n    &\n      :global(\n        .CalendarDay__blocked_out_of_range\n          .CalendarDay__blocked_calendar\n          .renderedDay\n      ) {\n      background-color: transparent;\n    }\n    & :global(.DateInput_fang) {\n      display: none;\n    }\n    & :global(.CalendarMonth_caption) {\n      text-transform: capitalize;\n    }\n\n    & :global(.DateInput_input__disabled) {\n      font-style: normal;\n    }\n  }\n}\n\n/* availableAccessories */\n.availableAccessories {\n  margin: 120px 0 0;\n  @media (max-width: 1023px) {\n    margin: 60px 0 0;\n  }\n  & .accessoriesContents {\n    display: flex;\n    gap: 30px;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    @media (max-width: 1023) {\n      justify-content: center;\n    }\n    & .accessoriesColumn {\n      max-width: 320px;\n      width: 100%;\n    }\n    & .accessoriesContent {\n      display: flex;\n      align-items: center;\n      margin-bottom: 24px;\n      & svg,\n      & img {\n        width: 24px;\n        height: 24px;\n        margin-right: 12px;\n      }\n      & h6 {\n        font-size: 18px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n/* hospitalityWrapper */\n.hospitalityWrapper {\n  margin: 120px 0 0;\n  @media (max-width: 1023px) {\n    margin: 60px 0 0;\n  }\n  .hospitalityColumns {\n    display: flex;\n    justify-content: space-between;\n    gap: 30px;\n    @media (max-width: 767px) {\n      flex-direction: column;\n    }\n    & > div {\n      max-width: 320px;\n      width: 100%;\n    }\n  }\n  & .hospitalityContents {\n    margin-top: 36px;\n    .hospitalityContent {\n      display: flex;\n      align-items: center;\n      margin-bottom: 16px;\n      & .textBold {\n        font-weight: 700;\n      }\n      & svg,\n      & img {\n        width: 24px;\n        height: 24px;\n        margin-right: 12px;\n      }\n    }\n  }\n}\n.fileAttachments {\n  margin: 120px 0 0;\n  @media (max-width: 1023px) {\n    margin: 60px 0 0;\n  }\n  & .attachmentsContents {\n    display: flex;\n    gap: 16px;\n    flex-direction: column;\n    .attachmentsContent {\n      display: flex;\n      @media (max-width: 1023px) {\n        flex-direction: column;\n      }\n      & .attachmentsText {\n        margin-bottom: 16px;\n        font-size: 20px;\n        margin-right: 12px;\n        font-weight: 700;\n        @media (max-width: 1023px) {\n          margin-bottom: 8px;\n          font-size: 18px;\n        }\n      }\n      & .linkText {\n        color: #4646f3;\n        font-size: 20px;\n        word-break: break-all;\n        font-weight: 600;\n        @media (max-width: 1023px) {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n/* locationWrapper */\n.locationWrapper {\n  margin: 120px 0;\n  @media (max-width: 1023px) {\n    margin: 60px 0;\n  }\n  & .mapContents {\n    & img,\n    & iframe {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      text-align: center;\n      object-fit: cover;\n    }\n    & .mapBox {\n      border: 1px solid grey;\n      border-radius: 4px;\n      padding: 24px;\n      position: relative;\n      width: 100%;\n      padding-top: 60%;\n      overflow: hidden;\n      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.3);\n      @media (max-width: 767px) {\n        padding-top: 120%;\n      }\n    }\n  }\n}\n.spinner {\n  width: 35px;\n  height: 35px;\n  stroke: gray;\n  stroke-width: 3px;\n}\n.blur {\n  color: transparent;\n  text-shadow: 0 0 8px #000;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `VenueListingDetails_title__GnJkT`,
	"titleHospitality": `VenueListingDetails_titleHospitality__kxGKd`,
	"subTitle": `VenueListingDetails_subTitle__EKbuI`,
	"rehearsalCheck": `VenueListingDetails_rehearsalCheck__SVT3T`,
	"listingDetailsWrapper": `VenueListingDetails_listingDetailsWrapper__+yX5W`,
	"timeInputs": `VenueListingDetails_timeInputs__QVwZ+`,
	"boldText": `VenueListingDetails_boldText__Z7T6W`,
	"orderText": `VenueListingDetails_orderText__z2oQd`,
	"summaryContent": `VenueListingDetails_summaryContent__jrDL-`,
	"reasonLabel": `VenueListingDetails_reasonLabel__bd+mL`,
	"rightTexts": `VenueListingDetails_rightTexts__D9djh`,
	"priceCount": `VenueListingDetails_priceCount__YLEci`,
	"selectMenu": `VenueListingDetails_selectMenu__tV7nF`,
	"genreText": `VenueListingDetails_genreText__GUk2N`,
	"multiSelectBox": `VenueListingDetails_multiSelectBox__xnwrZ`,
	"contentWrapper": `VenueListingDetails_contentWrapper__fXbQP`,
	"leftContents": `VenueListingDetails_leftContents__Ab-Kc`,
	"venueTitle": `VenueListingDetails_venueTitle__ei9Jy`,
	"venueName": `VenueListingDetails_venueName__ADWeB`,
	"addressText": `VenueListingDetails_addressText__kUdZj`,
	"orderWrapper": `VenueListingDetails_orderWrapper__NbpDv`,
	"chooseListing": `VenueListingDetails_chooseListing__b-clC`,
	"bookButton": `VenueListingDetails_bookButton__klwCn`,
	"calendlyButton": `VenueListingDetails_calendlyButton__JhO5P`,
	"orderContents": `VenueListingDetails_orderContents__LCkRF`,
	"priceContent": `VenueListingDetails_priceContent__TjQv6`,
	"priceText": `VenueListingDetails_priceText__3ecO+`,
	"vatText": `VenueListingDetails_vatText__LQ+zP`,
	"orderContent": `VenueListingDetails_orderContent__q9Wta`,
	"countNumber": `VenueListingDetails_countNumber__xXLAd`,
	"countQuantity": `VenueListingDetails_countQuantity__167OU`,
	"registeredText": `VenueListingDetails_registeredText__cTTb2`,
	"calenderText": `VenueListingDetails_calenderText__gjEBn`,
	"availableAccessories": `VenueListingDetails_availableAccessories__94+V8`,
	"accessoriesContents": `VenueListingDetails_accessoriesContents__UkNcC`,
	"accessoriesColumn": `VenueListingDetails_accessoriesColumn__T-jHU`,
	"accessoriesContent": `VenueListingDetails_accessoriesContent__TF9B-`,
	"hospitalityWrapper": `VenueListingDetails_hospitalityWrapper__hZpYW`,
	"hospitalityColumns": `VenueListingDetails_hospitalityColumns__bY2ZI`,
	"hospitalityContents": `VenueListingDetails_hospitalityContents__BE6gq`,
	"hospitalityContent": `VenueListingDetails_hospitalityContent__5WFm8`,
	"textBold": `VenueListingDetails_textBold__1gnZu`,
	"fileAttachments": `VenueListingDetails_fileAttachments__0gJB-`,
	"attachmentsContents": `VenueListingDetails_attachmentsContents__90qsq`,
	"attachmentsContent": `VenueListingDetails_attachmentsContent__xS6Sx`,
	"attachmentsText": `VenueListingDetails_attachmentsText__EYkET`,
	"linkText": `VenueListingDetails_linkText__+hM2o`,
	"locationWrapper": `VenueListingDetails_locationWrapper__8wkaq`,
	"mapContents": `VenueListingDetails_mapContents__0Ke4J`,
	"mapBox": `VenueListingDetails_mapBox__Bcu6d`,
	"spinner": `VenueListingDetails_spinner__jep4i`,
	"blur": `VenueListingDetails_blur__AGBd8`,
	"capitalize": `VenueListingDetails_capitalize__XUkvi`
};
export default ___CSS_LOADER_EXPORT___;
